import { RADIUS_XL } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const CardBase = styled.div`
    border-radius: ${RADIUS_XL};
    overflow: hidden;
`;

export default CardBase;
